export default function (_this) {
  return {
    add (files) {
      return new Promise((resolve) => {
        _this.getRef('files').update(files, () => {
          resolve()
        })
      })
    },
    read (cb) {
      _this.getRef('files').on('value', (snapshot) => {
        cb(snapshot.val())
      })
    },
    delete (id) {
      _this.getRef('files')
        .child(id)
        .remove()
    }
  }
}
